import type { App } from 'vue'

// 全量引入 Element Plus 样式。
// 本项目大量使用 `import { ElXxx } from 'element-plus'` 显式按名导入，
// 而 unplugin 的 ElementPlusResolver 只会为「模板里未显式导入」的组件注入样式，
// 对显式导入的组件不会注入样式，导致生产构建缺失大部分 Element Plus 样式。
// 因此这里直接全量引入样式，保证所有组件样式完整。
import 'element-plus/dist/index.css'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import { ElLoading, ElScrollbar } from 'element-plus'

const plugins = [ElLoading]

const components = [ElScrollbar]

export const setupElementPlus = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
